import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { E5coreUiSearchResultsBaseComponent } from './e5core-ui-search-results-base';
import { PageEvent, MatSort, MatPaginator, MatSpinner } from '@angular/material';
import { SearchMatTableDataSource } from './search-material-table-data-source';
import { SearchDataSourceService } from '../../../datasource/search-data-source.service';
import { DataSourceColumn } from '../../../datasource/data-source-column';
import { DataSourceQuery } from '../../../datasource/data-source-query';

export interface ColumnDef {
	name: string;
	label: string;
	type: string;
	status: number; // 0 Hidden, 1 available, 2 selected
	cell(row: any[]): string;
}

// https://stackblitz.com/edit/dynamic-columns-mat-table?file=app%2Ftable-pagination-example.html
// https://github.com/angular/material2/issues/5927

@Component({
	selector: 'e5core-ui-search-results-material',
	templateUrl: './e5core-ui-search-results-material.component.html',
	styleUrls: ['./e5core-ui-search-results-material.component.css']
})
export class E5coreUiSearchResultsMaterialComponent extends E5coreUiSearchResultsBaseComponent implements OnInit, OnDestroy {

	//  From E5coreUiSearchResultsBaseComponent
	// @Input() searchResults$: BehaviorSubject<SearchResultsModel> ;
	// @Input() pagesizes: number[] ;
	// @Input() headings: UISearchFieldModel[] ;
	// @Input() properties: UIPropertyModel[] ;

	tableDataSource: SearchMatTableDataSource;
	isEmpty: boolean = false;

	length = 0;
	pageSize = 10;
	pageSizeOptions: number[];
	findClassId: number;
	loading: boolean = true ;
	delayedQuery: DataSourceQuery ;
	headings:DataSourceColumn[] ;

	// MatPaginator Output
	pageEvent: PageEvent;
	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;

	constructor(private searchService:SearchDataSourceService) {
		super();
	}

	ngOnInit() {
		this.pageSizeOptions = (this.pagesizes && this.pagesizes.length > 0) ? this.pagesizes : [5, 10, 25, 50];
		// this.tableDataSource = new SearchMatTableDataSource(this.datasource); // this.history.getHistory(id, 0, 10) ;

		this.tableDataSource = new SearchMatTableDataSource(this.datasource); // this.history.getHistory(id, 0, 10) ;
		this.tableDataSource.sort = this.sort;
		this.tableDataSource.paginator = this.paginator;
		this.tableDataSource.loadingEvents.subscribe(
			loading => { 
				this.loading = loading 
			}
		)
		// Load the columns
		this.loading = true ;
		this.datasource.columns().subscribe(
			dsColumns => {
				this.headings = dsColumns ;
				this.loading = false ;
				if(this.delayedQuery || this.autoSearch) {
					this.search(this.delayedQuery) ;
				}
			},
			error => {},
			() => {
				this.loading = false ;
			}
		)
	}

	ngOnDestroy() {
		// if (this.tableDataSource)
		// 	this.tableDataSource.loadingEvents.unsubscribe();
	}

	setPageSizeOptions(setPageSizeOptionsInput: string) {
		this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
	}

	/**
	 * Return the list of columns available in the table.
	 */
	columns(): ColumnDef[] {
		if (this.headings) {
			let cols = (this.headings
				.filter(f => f.code !== 'Id') // Id is added at the beginning
				.map<ColumnDef>(f => <ColumnDef>{
					label: f.label,
					name: f.code,
					type: f.type,
					status: f.status
				}));
			return (cols);
		}
		return [];
	}

	/**
	 * Return the list of column names that will be displayed in the table.
	 */
	displayedColumns(): string[] {
		var cols = this.columns()
			.filter(f => f.status > 1) // Selected only
			.map<string>(c => c.name);
		cols.unshift("Id");
		return (cols);
	}

	search(query:DataSourceQuery) {
		if(this.tableDataSource) 
			this.tableDataSource.search(query) ;
		else
			this.delayedQuery = query ;
	}

	reset() {
		this.tableDataSource.reset() ;
	}

	refresh() {
		this.tableDataSource.refresh() ;
	}

}
